import axios from "axios";
import { IScenario } from "../types/IScenario";
import MOCK_PLAYER_VIEW from '../mocks/PlayerStateMock';
import MOCK_PLAYER_BIG_VIEW from '../mocks/PlayerStateMock';
import MOCK_DEAD from '../mocks/DeadViewMock';

const ReqMethod = {
  post: "post",
  get: "get",
};

type RequestCallback = (is_ok: boolean, payload?: any) => void

export class MafiaService {
  private static  callback_req = async (method: string, url: string, callback: RequestCallback, data = {}) => {
    try {
      const res = axios({
        method,
        url,
        data,
        headers: {
          "Access-Control-Allow-Origin": "*"
        },
      });
      res
        .then((response: { data: { is_ok: any; payload: any; err: any; }; }) => {
          if(response.data){
            callback(response.data.is_ok, response.data.is_ok ? response.data.payload : response.data.err)
          } else {
            callback(false, 'Unknown Error');
          }
        })
        .catch((err: any) => {
          callback(false, `Error ${err}`);
        });
    } catch (err: any) {
      callback(false, `Error ${err}`);
    }
  }
  /*========== GET ==========
  ========================= */

  public static LobbyView =  async (server_id: any, status_callback: RequestCallback) => {
    MafiaService.callback_req(
      ReqMethod.get,
      `${process.env.REACT_APP_SERVER_URL}/lobby_view/${server_id}`,
      status_callback,
    );
  }

  public static PlayerView= async (server_id: any, player_name: any, status_callback: RequestCallback) => {
    if (process.env.REACT_APP_DEV_MODE === 'true') {
      //status_callback(true, MOCK_PLAYER_VIEW);
      status_callback(true, MOCK_PLAYER_BIG_VIEW);
      return;
    }
    MafiaService.callback_req(
      ReqMethod.get,
      `${process.env.REACT_APP_SERVER_URL}/player_view/${server_id}/${player_name}`,
      status_callback,
    );
  }

  public static GetDeadView= async (server_id: string, status_callback: RequestCallback) => {
    if (process.env.REACT_APP_DEV_MODE === 'true') {
      //status_callback(true, MOCK_PLAYER_VIEW);
      status_callback(true, MOCK_DEAD);
      return;
    }
    MafiaService.callback_req(
      ReqMethod.get,
      `${process.env.REACT_APP_SERVER_URL}/dead_view/${server_id}`,
      status_callback,
    );
  }

  /*========== POST ==========
  ========================= */

  public static CreateGame= async (server_id: string, name: string, uid: string, status_callback: RequestCallback) => {
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/create_game?name=${name}&id=${server_id}`,
      status_callback,
    );
  }
  public static JoinGame= async (server_id: string, name: string, uid: string, status_callback: RequestCallback) => {
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/join_game?name=${name}&id=${server_id}`,
      status_callback,
      JSON.stringify(uid)
    );
  }
  public static Disconnect= async (server_id: string, player_name: string, status_callback: RequestCallback) => {
    const name = player_name;
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/disconnect?name=${name}&id=${server_id}`,
      status_callback,
    );
  }
  public static StartGame= async (server_id: string, scenario: IScenario, player_name: string, status_callback: RequestCallback) => {
    const shuffle=true;
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/start_game?shuffle=${shuffle}&id=${server_id}&name=${player_name}`,
      status_callback,
      scenario
    );
  }
  public static EndGame= async (server_id: any, status_callback: any) => {
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/end_game?id=${server_id}`,
      status_callback,
    );
  }
  public static Act= async (server_id: string, source: number, target: number, status_callback: RequestCallback) => {
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/act?source_pos=${source}&target_pos=${target}&id=${server_id}`,
      status_callback);
  }
  public static RemoveAct= async (server_id: string, source: number, target: number, status_callback: RequestCallback) => {
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/remove_act?source_pos=${source}&target_pos=${target}&id=${server_id}`,
      status_callback,
    );
  }
  public static LynchMe= async (server_id: string, pos: number, status_callback: RequestCallback) => {
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/day_vote_kill?player_pos=${pos}&id=${server_id}`,
      status_callback,
    );
  }
  public static EndDay= async (server_id: string) => {
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/finish_day?id=${server_id}`,
      () => { },
    );
  }
  public static EndNight= async (server_id: string) => {
    MafiaService.callback_req(
      ReqMethod.post,
      `${process.env.REACT_APP_SERVER_URL}/finish_night?id=${server_id}`,
      () => { },
    );
  }
};

export default MafiaService;
